import React, { useCallback } from 'react'
import { PanelHeader } from '../../../../../components/Panel/PanelHeader';
import { PanelFooter } from '../../../../../components/Panel/PanelFooter';
import { IOpenPanel, IpanelGeneric } from '../../../../../Interfaces/IPanel';
import { IComboBox, IComboBoxOption, Panel, PanelType } from '@fluentui/react';
import { ComboBoxIDS } from '../../../../../components/generic/ComboBoxIDS';
import { UseComboRazon } from '../../../../../hooks/auxiliar/combo/UseComboRazon';
import { MessageBarResponse } from '../../../../../components/MessageBarResponse/MessageBarResponse';
import { ProgressBarLoading } from '../../../../../components/ProgressBarLoading/ProgressBarLoading';
import { UseNuevoRazonModelo } from './UseNuevoRazonModelo';
import { UseComboModelo } from '../../../../../hooks/auxiliar/combo/UseComboModelo';

export interface IPanel extends IOpenPanel {
    // reload: () => void;
}

const PanelNuevoRazonModelo = (props: IPanel) => {
    const { dataComboRazon, onClickComboRazon, _onkeyUpSearchRazon, comboBoxRefRazon } = UseComboRazon(props.isOpen ?? false);
    const { dataComboModelo, onClickComboModelo, _onkeyUpSearchModelo, comboBoxRefModelo } = UseComboModelo(props.isOpen ?? false);
    const { command, setCommand, postInsertarRazonModelo, loading, disableForm, reset, mensaje, status } = UseNuevoRazonModelo(props);

    const onChangeCombo = (
        event: React.FormEvent<IComboBox>,
        option?: IComboBoxOption,
        nombre?: string
    ) => {
        if (event !== undefined) {
            if (option) {
                switch (nombre) {
                    case "modelo":
                        setCommand({
                            ...command,
                            equipoModeloId: option.key.toString(),
                        });
                        break;
                    case "razon":
                        setCommand({
                            ...command,
                            razonId: option.key.toString(),
                        });
                        break;
                    default:
                        break;
                }
            }
        }
    };

    const onRenderHeader = useCallback(
        () => (
            <>
                <PanelHeader
                    textHeader={"Agregar Modelo"}
                    // subTextHeader={`Agregar nuevo registro`}
                />
            </>
        ),
        []
    );
    const onRenderFooter = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Guardar"
                    // texto2={"Salir"}
                    disableButton={disableForm}
                    onClick={postInsertarRazonModelo}
                    onDismiss={reset || (() => { })}
                />
            </>
        ),
        [disableForm, command]
    );

    // const close = () => {
    //     reset()
    //     if (onDismiss) {
    //         onDismiss();
    //     }
    // }

    return (
        <>
            <Panel
                type={PanelType.smallFixedFar}
                onRenderHeader={onRenderHeader}
                onRenderFooter={onRenderFooter}
                isFooterAtBottom
                isOpen={props.isOpen}
                onDismiss={reset}
            >
                <div className="ms-Grid" dir="ltr">
                    <div hidden={mensaje == ""}>
                        <MessageBarResponse
                            objetoResponse={{ codigo: status, mensaje: mensaje }}
                            close={true}
                        />
                    </div>
                    <div hidden={!loading}>
                        <ProgressBarLoading></ProgressBarLoading>
                    </div>
                    {!mensaje && (
                        <div className="ms-Grid-row" hidden={loading}>
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                <ComboBoxIDS
                                    title="Razones:"
                                    componentRef={comboBoxRefRazon}
                                    KeyUp={_onkeyUpSearchRazon}
                                    onClick={onClickComboRazon}
                                    options={dataComboRazon}
                                    onChange={(e, option) => {
                                        onChangeCombo(e, option, "razon");
                                    }}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                <ComboBoxIDS
                                    title="Modelos:"
                                    componentRef={comboBoxRefModelo}
                                    KeyUp={_onkeyUpSearchModelo}
                                    onClick={onClickComboModelo}
                                    options={dataComboModelo}
                                    onChange={(e, option) => {
                                        onChangeCombo(e, option, "modelo");
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </Panel>
        </>
    )
}

export { PanelNuevoRazonModelo }